/*
 *  Protractor support is deprecated in Angular.
 *  Protractor is used in this example for compatibility with Angular documentation tools.
 */

import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import {bootstrapApplication, provideProtractorTestingSupport} from '@angular/platform-browser';
import {App} from './app/app';
import { environment} from './environments/environment';

if(environment.production){
  enableProdMode();
}

bootstrapApplication(App, {providers: [provideProtractorTestingSupport()]}).catch((err) =>
  console.error(err),
);
